import React from 'react'
import { useTranslation } from 'react-i18next';
import { AlertCircle, AlertTriangle, CheckCircle2 } from 'lucide-react';
import Table from '../Table';
import './exception-content.scss';
import { useParams } from 'react-router-dom';

const ExceptionContent = () => {
	const { t } = useTranslation();
	const { id } = useParams();
	const pageHeading = {
		exceptions: {
			heading: t('library_troubleshooting'),
			description: t('exceptions_desc')
		},
		'api-errors': {
			heading: t('api_troubleshooting'),
			description: t('api_errors_desc')
		}
	}
	const Errorcolumns = [
		{
			heading: `${t('code')}`,
			accessor: 'code',
			width: '1%',
			align: 'left',
			Cell: ({ value }) => (
				<div className="exceptions-page__cell">
					<div className="exceptions-page__code">
						<span className="exceptions-page__code-mark" aria-hidden="true">#</span>
						<span className="exceptions-page__code-value">{value}</span>
					</div>
				</div>
			),
		},
		{
			heading: `${t('type')}`,
			accessor: 'type',
			width: '1%',
			align: 'left',
			Cell: ({ value }) => (
				<div className="exceptions-page__cell">
					<div className={`exceptions-page__status exceptions-page__status--${value}`}>
						<span className="exceptions-page__status-dot" aria-hidden="true" />
						<span className="exceptions-page__status-label">{value}</span>
					</div>
				</div>
			),
		},
		{
			heading: `${t('key')}`,
			accessor: 'key',
			width: '24%',
			align: 'left',
			Cell: ({ value }) => (
				<code className="exceptions-page__key">{value}</code>
			),
		},
		{
			heading: `${t('message')}`,
			align: 'left',
			Cell: ({ row }) => (
				<div className="exceptions-page__message">{t(row.message)}</div>
			),
		}
	]

	const apiErrors = [
		{
			code: 40000,
			type: 'error',
			key: 'invalid_credentials',
			message: 'invalid_credentials'
		},
		{
			code: 40001,
			type: 'error',
			key: 'something_went_wrong',
			message: 'something_went_wrong'
		},
		{
			code: 40002,
			type: 'error',
			key: 'invalid_or_expired_token',
			message: 'invalid_or_expired_token'
		},
		{
			code: 40003,
			type: 'error',
			key: 'assessment_not_found',
			message: 'assessment_not_found'
		},
		{
			code: 40004,
			type: 'error',
			key: 'invalid_school',
			message: 'invalid_school'
		},
		{
			code: 40005,
			type: 'error',
			key: 'session_exist',
			message: 'session_exist'
		},
		{
			code: 40006,
			type: 'error',
			key: 'otp_expired',
			message: 'otp_expired'
		},
		{
			code: 40007,
			type: 'error',
			key: 'invalid_email_or_otp',
			message: 'invalid_email_or_otp'
		},
		{
			code: 40008,
			type: 'error',
			key: 'user_not_found',
			message: 'user_not_found'
		},
		{
			code: 40009,
			type: 'error',
			key: 'token_required',
			message: 'token_required'
		},
		{
			code: 40010,
			type: 'error',
			key: 'invalid_verification',
			message: 'invalid_verification'
		},
		{
			code: 40011,
			type: 'error',
			key: 'profile_not_found',
			message: 'profile_not_found'
		},
		{
			code: 40012,
			type: 'error',
			key: 'image_not_provided',
			message: 'image_not_provided'
		},
		{
			code: 40013,
			type: 'error',
			key: 'invalid_payload',
			message: 'invalid_payload'
		},
		{
			code: 40014,
			type: 'error',
			key: 'invalid_profile_id',
			message: 'invalid_profile_id'
		},
		{
			code: 40015,
			type: 'error',
			key: 'general_error',
			message: 'general_error'
		},
		{
			code: 40016,
			type: 'error',
			key: 'invalid_branch',
			message: 'invalid_branch'
		},
		{
			code: 40017,
			type: 'error',
			key: 'recording_not_started',
			message: 'recording_not_started'
		},
		{
			code: 40018,
			type: 'error',
			key: 'recording_not_stopped',
			message: 'recording_not_stopped'
		},
		{
			code: 40019,
			type: 'error',
			key: 'profile_required',
			message: 'profile_required'
		},
		{
			code: 40020,
			type: 'error',
			key: 'not_superuser',
			message: 'not_superuser'
		},
		{
			code: 40021,
			type: 'error',
			key: 'instructor_required',
			message: 'instructor_required'
		},
		{
			code: 40022,
			type: 'error',
			key: 'invalid_instructor',
			message: 'invalid_instructor'
		},
		{
			code: 40023,
			type: 'error',
			key: 'invalid_token',
			message: 'invalid_token'
		},
		{
			code: 40024,
			type: 'error',
			key: 'missing_required_fields',
			message: 'missing_required_fields'
		},
		{
			code: 40025,
			type: 'error',
			key: 'serialization_error',
			message: 'serialization_error'
		},
		{
			code: 40026,
			type: 'error',
			key: 'email_error',
			message: 'email_error'
		},
		{
			code: 40027,
			type: 'error',
			key: 'request_error',
			message: 'request_error'
		},
		{
			code: 40028,
			type: 'error',
			key: 'already_registered',
			message: 'already_registered'
		},
		{
			code: 40029,
			type: 'error',
			key: 'playlist_not_associated',
			message: 'playlist_not_associated'
		},
		{
			code: 40031,
			type: 'error',
			key: 'invalid_request_data',
			message: 'invalid_request_data'
		},
		{
			code: 40032,
			type: 'error',
			key: 'method_not_allowed',
			message: 'method_not_allowed'
		},
		{
			code: 40033,
			type: 'error',
			key: 'instructor_not_found',
			message: 'instructor_not_found'
		},
		{
			code: 40034,
			type: 'error',
			key: 'role_required',
			message: 'role_required'
		},
		{
			code: 40035,
			type: 'error',
			key: 'invalid_role',
			message: 'invalid_role'
		},
		{
			code: 40036,
			type: 'error',
			key: 'not_an_account_manager',
			message: 'not_an_account_manager'
		},
		{
			code: 40037,
			type: 'error',
			key: 'id_not_found',
			message: 'id_not_found'
		},
		{
			code: 50000,
			type: 'success',
			key: 'object_deleted',
			message: 'object_deleted'
		},
		{
			code: 50001,
			type: 'success',
			key: 'password_reset',
			message: 'password_reset'
		},
		{
			code: 50002,
			type: 'success',
			key: 'password_reset_token_sent',
			message: 'password_reset_token_sent'
		},
		{
			code: 50003,
			type: 'success',
			key: 'otp_sent',
			message: 'otp_sent'
		}
	];

	const exceptionData = [
		{
			code: 40000,
			key: 'error_in_prechecks_setup',
			type: 'error',
			message: 'error_in_prechecks_setup_desc',
		},
		{
			code: 40001,
			key: 'error_in_stop_prechecks',
			type: 'error',
			message: 'error_in_stop_prechecks_desc',
		},
		{
			code: 40002,
			key: 'error_in_mobile_proctoring_setup',
			type: 'error',
			message: 'error_in_mobile_proctoring_setup_desc',
		},
		{
			code: 40003,
			key: 'error_in_web_room_creation',
			type: 'error',
			message: 'error_in_web_room_creation_desc',
		},
		{
			code: 40004,
			key: 'error_in_starting_the_session',
			type: 'error',
			message: 'error_in_starting_the_session_desc',
		},
		{
			code: 40005,
			key: 'candidate_clicked_on_browser_back_button',
			type: 'error',
			message: 'candidate_clicked_on_browser_back_button_desc',
		},
		{
			code: 40006,
			key: 'signaling_connection_disconnected',
			type: 'error',
			message: 'signaling_connection_disconnected_desc',
		},
		{
			code: 40007,
			key: 'internet_connection_lost_force_close_your_session',
			type: 'error',
			message: 'internet_connection_lost_force_close_your_session_desc',
		},
		{
			code: 40008,
			key: 'mobile_connection_disconnected',
			type: 'error',
			message: 'mobile_connection_disconnected_desc',
		},
		{
			code: 40009,
			key: 'error_on_start_mobile_recording',
			type: 'error',
			message: 'error_on_start_mobile_recording_desc',
		},
		{
			code: 40010,
			key: 'mobile_phone_disconnected',
			type: 'error',
			message: 'mobile_phone_disconnected_desc',
		},
		{
			code: 40011,
			key: 'please_share_your_screen',
			type: 'error',
			message: 'please_share_your_screen_desc',
		},
		{
			code: 40012,
			key: 'screen_share_stopped',
			type: 'error',
			message: 'screen_share_stopped_desc',
		},
		{
			code: 40013,
			key: 'session_is_terminated_due_to_slow_internet_connection',
			type: 'error',
			message: 'session_is_terminated_due_to_slow_internet_connection_desc',
		},
		{
			code: 40014,
			key: 'web_internet_connection_disconnected',
			type: 'error',
			message: 'web_internet_connection_disconnected_desc',
		},
		{
			code: 40015,
			key: 'mobile_internet_connection_disconnected',
			type: 'error',
			message: 'mobile_internet_connection_disconnected_desc',
		},
		{
			code: 40016,
			key: 'error_in_stopping_the_session',
			type: 'error',
			message: 'error_in_stopping_the_session_desc',
		},
		{
			code: 40016,
			key: 'mobile_connection_failed',
			type: 'error',
			message: 'mobile_connection_failed_desc',
		},
		{
			code: 40017,
			key: 'mobile_phone_disconnected',
			type: 'error',
			message: 'mobile_phone_disconnected_desc',
		},
		{
			code: 40018,
			key: 'error_saving_session_info',
			type: 'error',
			message: 'error_saving_session_info_desc',
		},
		{
			code: 40019,
			key: 'camera_is_stopped',
			type: 'error',
			message: 'camera_is_stopped_desc',
		},
		{
			code: 40019,
			key: 'camera_permission_denied',
			type: 'error',
			message: 'camera_permission_denied_desc',
		},
		{
			code: 40019,
			key: 'candidate_came_back_to_assessment_page',
			type: 'error',
			message: 'candidate_came_back_to_assessment_page_desc',
		},
		{
			code: 40019,
			key: 'candidate_move_back_or_forward_from_the_page',
			type: 'error',
			message: 'candidate_move_back_or_forward_from_the_page_desc',
		},
		{
			code: 40019,
			key: 'candidate_refreshed_the_assessment_page',
			type: 'error',
			message: 'candidate_refreshed_the_assessment_page_desc',
		},
		{
			code: 40019,
			key: 'microphone_is_stopped',
			type: 'error',
			message: 'microphone_is_stopped_desc',
		},
		{
			code: 40019,
			key: 'microphone_permission_denied',
			type: 'error',
			message: 'microphone_permission_denied_desc',
		},
		{
			code: 40019,
			key: 'please_complete_your_prechecks',
			type: 'error',
			message: 'please_complete_your_prechecks_desc',
		},
		{
			code: 40019,
			key: 'recording_info_unavailable',
			type: 'warning',
			message: 'recording_info_unavailable_desc',
		},
		{
			code: 40020,
			key: 'invalid_or_missing_token',
			type: 'error',
			message: 'invalid_or_missing_token_desc',
		},
		{
			code: 40021,
			key: 'no_active_session_found',
			type: 'error',
			message: 'no_active_session_found_desc',
		},
		{
			code: 40021,
			key: 'some_fields_are_wrong_or_data_is_incorrect',
			type: 'error',
			message: 'some_fields_are_wrong_or_data_is_incorrect_desc',
		},
		{
			code: 40022,
			key: 'device_reconnection_failed',
			type: 'error',
			message: 'device_reconnection_failed_desc',
		},
		{
			code: 40022,
			key: 'error_in_init_function',
			type: 'error',
			message: 'error_in_init_function_desc',
		},
		{
			code: 40023,
			key: 'authentication_required',
			type: 'error',
			message: 'authentication_required_desc',
		},
		{
			code: 40023,
			key: 'token_expired_login_again_to_perform_this_action',
			type: 'error',
			message: 'token_expired_login_again_to_perform_this_action_desc',
		},
		{
			code: 40024,
			key: 'mobile_devices_are_not_supported_use_desktop',
			type: 'error',
			message: 'mobile_devices_are_not_supported_use_desktop_desc',
		},
		{
			code: 40025,
			key: 'your_browser_version_is_not_compatible',
			type: 'error',
			message: 'your_browser_version_is_not_compatible_desc',
		},
		{
			code: 40026,
			key: 'candidate_left_the_page',
			type: 'error',
			message: 'candidate_left_the_page_desc',
		},
		{
			code: 40026,
			key: 'internet_connection_unstable',
			type: 'error',
			message: 'internet_connection_unstable_desc',
		},
		{
			code: 40027,
			key: 'face_not_detected',
			type: 'error',
			message: 'face_not_detected_desc',
		},
		{
			code: 40028,
			key: 'multiple_face_detected',
			type: 'error',
			message: 'multiple_face_detected_desc',
		},
		{
			code: 40029,
			key: 'face_not_detected',
			type: 'error',
			message: 'face_not_detected_desc',
		},
		{
			code: 40030,
			key: 'webcam_error',
			type: 'error',
			message: 'webcam_error_desc',
		},
		{
			code: 40031,
			key: 'id_not_verified',
			type: 'error',
			message: 'id_not_verified_desc',
		},
		{
			code: 40032,
			key: 'api_verification_failed',
			type: 'error',
			message: 'api_verification_failed_desc',
		},
		{
			code: 40033,
			key: 'internet_connection_unstable',
			type: 'error',
			message: 'internet_connection_unstable_desc',
		},
		{
			code: 40034,
			key: 'pdf_extraction_error',
			type: 'error',
			message: 'pdf_extraction_error_desc',
		},
		{
			code: 40035,
			key: 'pdf_multiple_pages_error',
			type: 'error',
			message: 'pdf_multiple_pages_error_desc',
		},
		{
			code: 40036,
			key: 'location_not_working',
			type: 'error',
			message: 'location_not_working_desc',
		},
		{
			code: 40037,
			key: 'multiple_screens_detected',
			type: 'error',
			message: 'multiple_screens_detected_desc',
		},
		{
			code: 40038,
			key: 'webcam_not_working',
			type: 'error',
			message: 'webcam_not_working_desc',
		},
		{
			code: 40039,
			key: 'microphone_not_working',
			type: 'error',
			message: 'microphone_not_working_desc',
		},
		{
			code: 40040,
			key: 'location_not_working',
			type: 'error',
			message: 'location_not_working_desc',
		},
		{
			code: 40041,
			key: 'system_requirement_retry_failed',
			type: 'error',
			message: 'system_requirement_retry_failed_desc',
		},
		{
			code: 40042,
			key: 'check_media_error',
			type: 'error',
			message: 'check_media_error_desc',
		},
		{
			code: 40043,
			key: 'media_check_exception',
			type: 'error',
			message: 'media_check_exception_desc',
		},
		{
			code: 40044,
			key: 'browser_security_retry_failed',
			type: 'error',
			message: 'browser_security_retry_failed_desc',
		},
		{
			code: 40045,
			key: 'extensions_detected',
			type: 'error',
			message: 'extensions_detected_desc',
		},
		{
			code: 40046,
			key: 'extension_check_failed',
			type: 'error',
			message: 'extension_check_failed_desc',
		},
		{
			code: 40047,
			key: 'standard_browser_mode_detected',
			type: 'error',
			message: 'standard_browser_mode_detected_desc',
		},
		{
			code: 40048,
			key: 'audio_test_failed',
			type: 'error',
			message: 'audio_test_failed_desc',
		},
		{
			code: 40049,
			key: 'camera_access_lost',
			type: 'error',
			message: 'camera_access_lost_desc',
		},
		{
			code: 40050,
			key: 'camera_access_lost',
			type: 'error',
			message: 'camera_access_lost_desc',
		},
		{
			code: 40050,
			key: 'camera_in_use',
			type: 'error',
			message: 'camera_in_use_desc',
		},
		{
			code: 40050,
			key: 'camera_permission_denied',
			type: 'error',
			message: 'camera_permission_denied_desc',
		},
		{
			code: 40050,
			key: 'no_camera_found',
			type: 'error',
			message: 'no_camera_found_desc',
		},
		{
			code: 40051,
			key: 'something_went_wrong_please_upload_video_again',
			type: 'error',
			message: 'something_went_wrong_please_upload_video_again_desc',
		},
		{
			code: 40052,
			key: 'mobile_phone_disconnected_in_screen_share_screen',
			type: 'error',
			message: 'mobile_phone_disconnected_in_screen_share_screen_desc',
		},
		{
			code: 40053,
			key: 'failed_connect_with_mobile_video',
			type: 'error',
			message: 'failed_connect_with_mobile_video_desc',
		},
		{
			code: 40054,
			key: 'internet_connection_lost_during_mobile_connection',
			type: 'error',
			message: 'internet_connection_lost_during_mobile_connection_desc',
		},
		{
			code: 40055,
			key: 'mobile_phone_disconnected',
			type: 'error',
			message: 'mobile_phone_disconnected_desc',
		},
		{
			code: 40056,
			key: 'media_connection_failed',
			type: 'error',
			message: 'media_connection_failed_desc',
		},
		{
			code: 40057,
			key: 'signaling_connection_disconnected',
			type: 'error',
			message: 'signaling_connection_disconnected_desc',
		},
		{
			code: 40058,
			key: 'mobile_phone_disconnected_during_assessment',
			type: 'error',
			message: 'mobile_phone_disconnected_during_assessment_desc',
		},
		{
			code: 40059,
			key: 'multiple_people_detected_for_more_than_10_seconds',
			type: 'error',
			message: 'multiple_people_detected_for_more_than_10_seconds_desc',
		},
		{
			code: 40059,
			key: 'no_person_detected_for_more_than_10_seconds',
			type: 'error',
			message: 'no_person_detected_for_more_than_10_seconds_desc',
		},
		{
			code: 40059,
			key: 'unauthorized_object_detected_for_more_than_10_seconds',
			type: 'error',
			message: 'unauthorized_object_detected_for_more_than_10_seconds_desc',
		},
		{
			code: 40060,
			key: 'multiple_people',
			type: 'error',
			message: 'multiple_people_desc',
		},
		{
			code: 40060,
			key: 'object_detected',
			type: 'error',
			message: 'object_detected_desc',
		},
		{
			code: 40060,
			key: 'person_missing',
			type: 'error',
			message: 'person_missing_desc',
		},
		{
			code: 40061,
			key: 'failed_to_start_ai_webcam',
			type: 'error',
			message: 'failed_to_start_ai_webcam_desc',
		},
		{
			code: 40062,
			key: 'error_attaching_video_track',
			type: 'error',
			message: 'error_attaching_video_track_desc',
		},
		{
			code: 40063,
			key: 'error_on_starting_recording',
			type: 'error',
			message: 'error_on_starting_recording_desc',
		},
		{
			code: 40064,
			key: 'error_on_stop_recording',
			type: 'error',
			message: 'error_on_stop_recording_desc',
		},
		{
			code: 40065,
			key: 'room_is_not_creating',
			type: 'error',
			message: 'room_is_not_creating_desc',
		},
		{
			code: 40066,
			key: 'session_already_in_progress',
			type: 'error',
			message: 'session_already_in_progress_desc',
		},
		{
			code: 40066,
			key: 'system_diagnostic_retry_failed',
			type: 'error',
			message: 'system_diagnostic_retry_failed_desc',
		},
		{
			code: 50000,
			key: 'device_reconnected_successfully',
			type: 'success',
			message: 'device_reconnected_successfully_desc',
		},
		{
			code: 50000,
			key: 'recording_started_successfully',
			type: 'success',
			message: 'recording_started_successfully_desc',
		},
		{
			code: 50001,
			key: 'precheck_completed',
			type: 'success',
			message: 'precheck_completed_desc',
		},
		{
			code: 50002,
			key: 'prechecks_stopped',
			type: 'success',
			message: 'prechecks_stopped_desc',
		},
		{
			code: 50003,
			key: 'session_finished_successfully',
			type: 'success',
			message: 'session_finished_successfully_desc',
		},
		{
			code: 50004,
			key: 'init_function_complete',
			type: 'success',
			message: 'init_function_complete_desc',
		},
		{
			code: 50005,
			key: 'language_changed',
			type: 'success',
			message: 'language_changed_desc',
		},
		{
			code: 50006,
			key: 'mobile_phone_reconnected',
			type: 'success',
			message: 'mobile_phone_reconnected_desc',
		},
		{
			code: 50007,
			key: 'candidate_photo_uploaded_successfully',
			type: 'success',
			message: 'candidate_photo_uploaded_successfully_desc',
		},
		{
			code: 50007,
			key: 'detected_face_successfully',
			type: 'success',
			message: 'detected_face_successfully_desc',
		},
		{
			code: 50008,
			key: 'id_successfully_verified',
			type: 'success',
			message: 'id_successfully_verified_desc',
		},
		{
			code: 50009,
			key: 'identity_card_uploaded_successfully',
			type: 'success',
			message: 'identity_card_uploaded_successfully_desc',
		},
		{
			code: 50010,
			key: 'system_diagnostic_retry_success',
			type: 'success',
			message: 'system_diagnostic_retry_success_desc',
		},
		{
			code: 50011,
			key: 'system_requirement_retry_success',
			type: 'success',
			message: 'system_requirement_retry_success_desc',
		},
		{
			code: 50012,
			key: 'browser_security_retry_success',
			type: 'success',
			message: 'browser_security_retry_success_desc',
		},
		{
			code: 50013,
			key: 'audio_test_passed',
			type: 'success',
			message: 'audio_test_passed_desc',
		},
		{
			code: 50014,
			key: 'candidate_video_is_uploaded_successfully',
			type: 'success',
			message: 'candidate_video_is_uploaded_successfully_desc',
		},
		{
			code: 50015,
			key: 'screen_recording_window_shared',
			type: 'success',
			message: 'screen_recording_window_shared_desc',
		},
		{
			code: 50015,
			key: 'screen_shared_again',
			type: 'success',
			message: 'screen_shared_again_desc',
		},
		{
			code: 50016,
			key: 'mobile_phone_reconnected',
			type: 'success',
			message: 'mobile_phone_reconnected_desc',
		},
		{
			code: 50017,
			key: 'session_initiated',
			type: 'success',
			message: 'session_initiated_desc',
		},
		{
			code: 50018,
			key: 'session_started',
			type: 'success',
			message: 'session_started_desc',
		},
		{
			code: 50019,
			key: 'video_recording_reconnecting',
			type: 'success',
			message: 'video_recording_reconnecting_desc',
		},
		{
			code: 50020,
			key: 'video_recording_reconnected',
			type: 'success',
			message: 'video_recording_reconnected_desc',
		},
		{
			code: 400010,
			key: 'assessment_closed_due_to_multiple_violation',
			type: 'error',
			message: 'assessment_closed_due_to_multiple_violation_desc',
		}
	]

	const data = id === 'exceptions' ? exceptionData : apiErrors;
	return (
		<div className="exceptions-page">
			<div className="exceptions-page__container">
				<header className="exceptions-page__header">
					<h1 className="exceptions-page__title">{pageHeading[id]?.heading}</h1>
					<p className="exceptions-page__intro">
						{pageHeading[id]?.description}
					</p>
				</header>

				<section className="exceptions-page__section">
					<div className="exceptions-page__section-header">
						<div className="exceptions-page__section-icon exceptions-page__section-icon--error">
							<AlertCircle size={20} aria-hidden="true" />
						</div>
						<h2 className="exceptions-page__section-title">{t('errors')}</h2>
					</div>
					<Table
						column={Errorcolumns}
						data={data.filter(item => item.type === 'error')}
						showPagination={false}
						onSortedList={() => null}
						variant="modern"
					/>
				</section>

				<section className="exceptions-page__section">
					<div className="exceptions-page__section-header">
						<div className="exceptions-page__section-icon exceptions-page__section-icon--warning">
							<AlertTriangle size={20} aria-hidden="true" />
						</div>
						<h2 className="exceptions-page__section-title">{t('warnings')}</h2>
					</div>
					<Table
						column={Errorcolumns}
						data={data.filter(item => item.type === 'warning')}
						showPagination={false}
						onSortedList={() => null}
						variant="modern"
					/>
				</section>

				<section className="exceptions-page__section">
					<div className="exceptions-page__section-header">
						<div className="exceptions-page__section-icon exceptions-page__section-icon--success">
							<CheckCircle2 size={20} aria-hidden="true" />
						</div>
						<h2 className="exceptions-page__section-title">{t('success')}</h2>
					</div>
					<Table
						column={Errorcolumns}
						data={data.filter(item => item.type === 'success')}
						showPagination={false}
						onSortedList={() => null}
						variant="modern"
					/>
				</section>
			</div>
		</div>
	)
}

export default ExceptionContent